import * as client from "../../client";

// Return a stable, comparable key for sorting ReportContact,
// with support for a company_info fallback.
export const brokerSortValue = (
  contact: client.ReportContact | null | undefined,
  company_info: client.RawCompanyInfo
): string => {
  if (!contact) {
    return (company_info.broker_name ?? "").toLowerCase();
  }
  return (
    contact.full_name ||
    contact.organization_name ||
    contact.email ||
    company_info.broker_name ||
    ""
  ).toLowerCase();
};

/** Append "Z" if the timestamp lacks a timezone so the browser treats it as UTC. */
export const ensureUtc = (ts: string): string =>
  ts.endsWith("Z") ? ts : ts + "Z";

export const formatTimestamp = (ts: string): string => {
  const d = new Date(ensureUtc(ts));
  return d.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};

/**
 * Format to two decimals, but show "<0.01" for tiny positive values that
 * would otherwise round to "0.00" and read as zero.
 */
export const formatTwoDecimals = (n: number): string =>
  n > 0 && n < 0.005 ? "<0.01" : n.toFixed(2);

export const getPolicySourceNames = (
  sublimitInfo: client.SublimitInfo | null | undefined,
  deductibleInfo: client.AdvancedDeductibleInfo | null | undefined,
  limitInfo: client.AdvancedLimitInfo | null | undefined
): string[] => [
  ...new Set([
    ...Object.keys(sublimitInfo?.extracted_sublimits ?? {}),
    ...Object.keys(deductibleInfo?.extracted_deductibles ?? {}),
    ...Object.keys(limitInfo?.extracted_limits ?? {}),
  ]),
];
